var _linearGradient, _linearGradient2, _linearGradient3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22e6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c1ce"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(-35 0 0 -35 35 18.5)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    xlinkHref: "#a",
    y1: 0,
    y2: 0
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(-6 0 0 -6 92 8)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    xlinkHref: "#a",
    y1: 0,
    y2: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "matrix(2.43046 0 0 2.43243 96.5 155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.46 13.671c-2.818-2.806-7.296-2.806-10.084 0-2.788 2.837-2.758 7.455.03 10.291 2.787 2.837 7.325 2.868 10.113.031.047-.049.243-.268.588-.658l-3.362-3.425c-.346.409-.528.623-.548.642-.949.966-2.491.966-3.44 0-.949-.965-.949-2.535-.03-3.47.92-.936 2.462-.936 3.411.03 0 0 2.997 3.047 8.99 9.141-2.462 3.621-6.588 5.918-11.037 5.918-7.355 0-13.346-6.126-13.346-13.671s5.991-13.671 13.346-13.671c4.301 0 8.245 2.112 10.707 5.523-.397.468-1.41 1.644-3.04 3.527l3.317 3.365 5.506-6.319c-2.847-6.579-9.283-10.925-16.49-10.925-9.994 0-18.091 8.299-18.091 18.5s8.097 18.5 18.091 18.5c4.538 0 8.305-1.449 11.982-4.648 3.352-2.897 4.927-6.914 4.927-6.914z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.91 20.86v10.14h-4.138v-10.361c-.42-2.381-2.518-4.191-5.043-4.191-2.563 0-4.686 1.866-5.06 4.301v10.251h-4.139v-18.401l3.174 2.014c1.616-1.384 3.722-2.221 6.025-2.221 4.866 0 8.851 3.735 9.191 8.468zm-43.438-10.597c-1.375.716-2.603 1.675-3.627 2.819-1.529-2.116-4.019-3.494-6.832-3.494-4.65 0-8.42 3.766-8.42 8.412s3.77 8.412 8.42 8.412c1.51 0 2.927-.397 4.152-1.092.459 1.492 1.186 2.868 2.125 4.071-1.861 1.025-4.001 1.609-6.277 1.609-7.187 0-13.013-5.82-13.013-13s5.826-13 13.013-13c4.286 0 8.088 2.07 10.459 5.263zm6.157 20.737c-5.078 0-9.195-4.108-9.195-9.176s4.117-9.177 9.195-9.177 9.195 4.109 9.195 9.177-4.117 9.176-9.195 9.176zm0-4.078c2.821 0 5.108-2.283 5.108-5.098 0-2.816-2.287-5.098-5.108-5.098s-5.108 2.282-5.108 5.098c0 2.815 2.287 5.098 5.108 5.098zm11.749-14.275h4.087v18.353h-4.087zm44.444-3.25h-11.691v6.672h11.351v4.142h-11.351v6.647h11.691v4.142h-16.092v-25.745h16.092zm8.593 12.388-6.292-9.138h5.204c.153.256.377.607.672 1.055.345.524.703 1.068 1.073 1.631s.728 1.107 1.073 1.631c.343.521.587.908.732 1.158l.209.362 3.739-5.837h4.951l-6.181 8.984 6.405 9.369h-5.14l-3.945-5.999-.213.316c-.174.258-.434.656-.781 1.195-.345.537-.714 1.106-1.108 1.706-.396.603-.766 1.173-1.112 1.711-.294.458-.518.814-.671 1.071h-4.91z",
    fill: "#27282c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86 7.969c0-.805.294-1.501.881-2.088s1.29-.881 2.109-.881c.833 0 1.542.294 2.13.881.587.573.88 1.276.88 2.109s-.293 1.542-.88 2.13c-.574.587-1.277.88-2.11.88-.832 0-1.542-.293-2.129-.88-.587-.588-.881-1.304-.881-2.151z",
    fill: "url(#c)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinex);
export default __webpack_public_path__ + "static/media/coinex.8f3260a66d4e32d8ecd5bd8e004a66a3.svg";
export { ForwardRef as ReactComponent };